import { 
  TEpDevPEntityId 
} from "@solace-labs/backstage-plugin-ep-devp-common";

export enum EpDevPSupportIssues {
  ServiceUnavailable = "ServiceUnavailable",
  VerifyUserError = "VerifyUserError",
  PageNotFound = "PageNotFound",
  Unauthorized = "Unauthorized",
  ApiError = "ApiError",
  Unknown = "Unknown"
}

export type EpDevPContactSupportReferer = {
  referrerEntityId: TEpDevPEntityId;
  subject?: string;
  location: string;
  issueId: EpDevPSupportIssues;
  organizationId: string;
  details: any;
  cause?: EpDevPContactSupportReferer; 
}

